/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable no-async-promise-executor */
// NOTE: 'syncEventMessages' is for storing offline submitted pending
// event messages to sync with back end when get online
import connector from '../connector';

import userPermissions from './userPermissions';

const addEventMessage = (eventMessage, farmId) => new Promise(async (resolve, reject) => {
    try {
        const userId = localStorage.getItem('userId');
        if (userId) {
            const db = await connector();
            const transaction = db.transaction('syncEventMessages', 'readwrite');
            const syncEventMessagesStore = transaction.objectStore('syncEventMessages');

            const offlineId = Date.now();
            const eventMessageToSave = {
                userId,
                offlineId,
                ...eventMessage
            }

            const checkPermission = await userPermissions.checkHasPermission(farmId, 'write_log');
            if (checkPermission?.success && checkPermission?.permission) {
                syncEventMessagesStore.add(eventMessageToSave);
                transaction.oncomplete = () => {
                    db.close();
                    resolve({ success: true, offlineId });
                };
            }
            else {
                reject({ success: false, code: 403, error: 'Error: Permission denied!', });
            }

        }
        else {
            reject({ success: false, error: 'Error: User not found!' });
        }
    }
    catch (error) {
        reject({ success: false, error });
    }
});

const getEventMessagesList = () => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('syncEventMessages', 'readonly');
        const syncEventMessagesStore = transaction.objectStore('syncEventMessages');

        const allEventMessages = syncEventMessagesStore.getAll();

        transaction.oncomplete = () => {
            db.close();
            resolve({ success: true, data: allEventMessages.result });
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});

const getEventMessageByOfflineId = (offlineId) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('syncEventMessages', 'readonly');
        const syncEventMessagesStore = transaction.objectStore('syncEventMessages');

        const eventMessage = syncEventMessagesStore.get(offlineId);

        transaction.oncomplete = () => {
            db.close();
            if (eventMessage && eventMessage.result) {
                resolve({ success: true, eventMessage: eventMessage.result });
            }
            else {
                reject({ success: false, error: 404 });
            }
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});

const getEventMessagesListByEventId = (eventId) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('syncEventMessages', 'readonly');
        const syncEventMessagesStore = transaction.objectStore('syncEventMessages');
        const eventIdIndex = syncEventMessagesStore.index('EventIdIndex');

        const allEventMessages = eventIdIndex.getAll(eventId);

        transaction.oncomplete = () => {
            db.close();
            resolve({ success: true, data: allEventMessages.result });
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});

const deleteEventMessage = (offlineId) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('syncEventMessages', 'readwrite');
        const syncEventMessagesStore = transaction.objectStore('syncEventMessages');

        syncEventMessagesStore.delete(offlineId);

        transaction.oncomplete = () => {
            db.close();
            resolve({ success: true });
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});


const syncEventMessages = {
    addEventMessage,
    getEventMessagesList,
    getEventMessageByOfflineId,
    getEventMessagesListByEventId,
    deleteEventMessage
}

export default syncEventMessages;
